import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

// Catches 412 `needs_tenant_creation` / `needs_active_tenant` from any admin endpoint and
// navigates to `/onboarding/create-company` or `/tenant-picker`; skips navigation when already there.
export const activeTenantResolutionInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status !== 412 || !isErrorEnvelope(err.error)) {
        return throwError(() => err);
      }
      const code = err.error.error;
      const here = currentPath();

      if (code === 'needs_tenant_creation' && here !== '/onboarding/create-company') {
        router.navigateByUrl('/onboarding/create-company');
      } else if (code === 'needs_active_tenant' && here !== '/tenant-picker') {
        router.navigateByUrl('/tenant-picker');
      }

      // Always re-throw - the navigation is best-effort, the caller still needs
      // to know its request failed so it can stop spinners / reset state.
      return throwError(() => err);
    }),
  );
};

function isErrorEnvelope(v: unknown): v is { error: string } {
  return !!v && typeof v === 'object' && typeof (v as { error?: unknown }).error === 'string';
}

function currentPath(): string {
  if (typeof globalThis === 'undefined' || !globalThis.location) return '';
  return globalThis.location.pathname || '/';
}
